import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

export default function PageNotFound() {
  const location = useLocation();
  const pageName = location.pathname.substring(1) || 'página desconocida';

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="max-w-md w-full">
        <div className="text-center space-y-6">
          {/* 404 Error Code */}
          <div className="space-y-2">
            <h1 className="text-8xl font-light text-foreground/20 font-serif-display">404</h1>
            <div className="h-0.5 w-16 bg-accent/30 mx-auto"></div>
          </div>
          
          {/* Main Message */}
          <div className="space-y-4">
            <h2 className="font-serif-display text-3xl font-light text-foreground">
              Página no encontrada
            </h2>
            <p className="text-foreground/60 font-light leading-relaxed">
              La página <span className="font-medium text-foreground/80">"{pageName}"</span> no existe en este sitio.
            </p>
            <p className="text-sm text-foreground/40 font-light">
              Es posible que el enlace esté roto o la página haya sido eliminada.
            </p>
          </div>
          
          {/* Action Buttons */}
          <div className="pt-6 flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-accent text-white font-light tracking-wide hover:bg-accent/80 transition-colors duration-300"
            >
              <Home size={18} />
              Ir al inicio
            </Link>
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-border text-foreground/70 font-light hover:bg-secondary/50 transition-colors duration-300"
            >
              <ArrowLeft size={18} />
              Volver atrás
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}